// extracted by mini-css-extract-plugin
export default {"camera__container":"styles_camera__container__rKqWt"};